/**
 * Legacy jQuery/Leaflet initialization
 * Migrated from app/assets/javascripts/application.js.erb
 */

import $ from "jquery";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import "./lib/leaflet-tilelayer-nogap";
import { initModalShim } from "./lib/bootstrap-modal-shim";

// Bootstrap-compatible modal shim (no Bootstrap JS required)
initModalShim($);

// Expose Leaflet globally for Vue components (listing-map, listing-approximate-map)
window.L = L;
import Rails from "@rails/ujs";
import * as ActiveStorage from "@rails/activestorage";

// Expose jQuery globally for Vue app and other scripts
window.$ = window.jQuery = $;

// Rails UJS and Active Storage
Rails.start();
ActiveStorage.start();

function initLegacy() {
  // Vimeo player for promo video modal
  const $frame = $("iframe#promovideo");
  if ($frame.length && typeof window.Vimeo !== "undefined") {
    const $player = new window.Vimeo.Player($frame[0]);
    $("#watchvideo").on("shown.bs.modal", function() {
      $player.play();
    });
    $("#watchvideo").on("hidden.bs.modal", function() {
      $player.pause();
    });
  }

  const headerHeight = ($(".navbar-main").outerHeight() || 0) + 15;

  $.fn.focusNoScroll = function() {
    const x = window.scrollX;
    const y = window.scrollY;
    this.focus();
    window.scrollTo(x, y);
    return this;
  };

  $('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .on("click", function(event) {
      if (
        location.pathname.replace(/^\//, "") ===
          this.pathname.replace(/^\//, "") &&
        location.hostname === this.hostname
      ) {
        const target = $(this.hash);
        const $target = target.length
          ? target
          : $(`[name=${this.hash.slice(1)}]`);
        if ($target.length) {
          event.preventDefault();
          $("html, body").animate(
            {
              scrollTop: $target.offset().top - headerHeight,
            },
            1000,
            function() {
              $target.attr("tabindex", "-1");
              $target.focusNoScroll();
            },
          );
        }
      }
    });

  const scroller = function() {
    const nav = $(".navbar.navbar-main");
    const scroll = $(window).scrollTop();
    if (scroll > 0) {
      nav.addClass("navbar-scrolled");
    } else {
      nav.removeClass("navbar-scrolled");
    }
  };

  $(window).on("scroll", scroller);
  scroller();

  const toggleTargets = document.getElementsByClassName("toggle__target");
  const toggleControls = document.getElementsByClassName("toggle__control");

  const toggleItem = function(control) {
    const target = document.getElementById($(control).attr("data-target"));
    if (!target) return;

    $(toggleControls).each(function() {
      $(this).removeClass("toggle__item--active");
    });
    $(control).addClass("toggle__item--active");
    $(toggleTargets).each(function() {
      $(this).removeClass("toggle__target--active");
    });
    $(target).addClass("toggle__target--active");
  };

  $(".toggle__item").on("click", function(e) {
    e.preventDefault();
    toggleItem($(this));
  });

  // Copy listing link to clipboard
  $(document).on("click", ".listing__share-copy", function(e) {
    e.preventDefault();
    const url = $(this).data("listing-url");
    const $text = $(this).find(".listing__share-copy-text");
    const originalText = $text.text();

    const copyToClipboard = (text) => {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text);
      }
      const input = document.createElement("input");
      input.value = text;
      input.setAttribute("readonly", "");
      input.style.position = "absolute";
      input.style.left = "-9999px";
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand("copy");
        return Promise.resolve();
      } finally {
        document.body.removeChild(input);
      }
    };

    copyToClipboard(url).then(() => {
      $text.text("Copied!");
      setTimeout(() => {
        $text.text(originalText);
      }, 2000);
    }).catch(() => {
      $text.text("Copy failed");
      setTimeout(() => {
        $text.text(originalText);
      }, 2000);
    });
  });
}

$(document).on("load", initLegacy);
